module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=VI - United States Virgin Islands.d57a115b.svg";